// Where to send someone after they sign in (e.g. back to a stock's reports page).
// Kept in sessionStorage so it survives full page loads; only same-site paths are accepted.
const KEY = "ab_return_to";

export function safePath(p) {
  return typeof p === "string" && p.startsWith("/") && !p.startsWith("//") && !p.startsWith("/login") ? p : "";
}

export function setReturnTo(path) {
  const p = safePath(path);
  try {
    if (p) sessionStorage.setItem(KEY, p);
  } catch {
    /* storage unavailable: fall back to router state / ?next */
  }
}

export function takeReturnTo(fallback) {
  let p = "";
  try {
    p = safePath(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return p || fallback;
}
